export default "__VITE_ASSET__DJlp0SeA__"